import { applyTier, graphicsNote } from './graphics';
import { defineSetting } from './settingsRegistry';

declare module './settingsRegistry' {
  interface Settings {
    /**
     * Graphics quality (graphics.ts): 0 ต่ำมาก … 4 สูงมาก. Picking one presets lighting, ambience,
     * shake, flash and the window blur, and sets the characters' density (after a reload), the
     * screen's sharpness, the crowd drawn, the cloth and the particles. Guessed on the first run.
     */
    graphics: number;
  }
}

/**
 * The tiers' names in the menu, lowest first. Kept here, not in graphics.ts: this file is loaded
 * while settings.ts loads, which graphics.ts imports, and only its functions may be used before it runs.
 */
export const TIER_NAMES = ['ต่ำมาก', 'ต่ำ', 'ปานกลาง', 'สูง', 'สูงมาก'] as const;

defineSetting({
  key: 'graphics',
  default: 3,
  order: 35,
  range: [0, 4],
  menu: {
    group: 'visual',
    label: 'คุณภาพกราฟิก',
    choices: TIER_NAMES,
    changed: (v) => applyTier(v),
    note: () => graphicsNote(),
  },
});
